// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G32O","label":"styles_label__2pjOL"};